// frontend/src/pages/EmailVerified.tsx

import React from 'react'
import { useSearchParams, Link } from 'react-router-dom'

export default function EmailVerified() {
  const [sp] = useSearchParams()
  const status = sp.get('status') || 'verified'
  return (
    <div style={{ maxWidth:520, margin:'40px auto' }}>
      <h1 style={{ fontSize:24, fontWeight:700, marginBottom:16 }}>Email {status}</h1>
      <p>Your email has been verified. You can continue.</p>
      <Link to="/dashboard">Go to Dashboard</Link>
    </div>
  )
}
